<ng-container *ngIf="address$ | async as address">
  <strong>Address: </strong>{{ address }}
</ng-container>
